import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
    Action,
    createFeatureSelector,
    createReducer,
    createSelector,
    on
} from '@ngrx/store';
import * as UserSettingActions from './user-setting.actions';
import { UserSetting, UserSettingEmpSettingType } from './user-setting.model';

export const userSettingsFeatureKey = 'userSettings';

export interface State extends EntityState<UserSetting> {
    // additional entities state properties
}

export const adapter: EntityAdapter<UserSetting> =
    createEntityAdapter<UserSetting>({
        selectId: (model: UserSetting) => model.EmpSettingType
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const userSettingReducer = createReducer(
    initialState,
    on(UserSettingActions.addUserSetting, (state, action) =>
        adapter.addOne(action.userSetting, state)
    ),
    on(UserSettingActions.upsertUserSetting, (state, action) =>
        adapter.upsertOne(action.userSetting, state)
    ),
    on(UserSettingActions.addUserSettings, (state, action) =>
        adapter.addMany(action.userSettings, state)
    ),
    on(UserSettingActions.upsertUserSettings, (state, action) =>
        adapter.upsertMany(action.userSettings, state)
    ),
    on(UserSettingActions.updateUserSetting, (state, action) =>
        adapter.updateOne(action.userSetting, state)
    ),
    on(UserSettingActions.updateUserSettings, (state, action) =>
        adapter.updateMany(action.userSettings, state)
    ),
    on(UserSettingActions.deleteUserSetting, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(UserSettingActions.deleteUserSettings, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    //this is clearing any user settings that are not in the action.userSettings
    //this causes issues b/c the API get doesn't appear to return all user settings
    // on(UserSettingActions.loadUserSettings, (state, action) =>
    //     adapter.setAll(action.userSettings, state)
    // ),
    on(UserSettingActions.loadUserSettings, (state, action) =>
        adapter.upsertMany(action.userSettings, state)
    ),
    on(UserSettingActions.clearUserSettings, state => adapter.removeAll(state)),
    on(UserSettingActions.deleteUserAIHelpButton, state =>
        adapter.removeOne(UserSettingEmpSettingType.UserAIHelpButton, state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return userSettingReducer(state, action);
}
